import Link from "next/link";
import type { VertexSearchResult } from "@jetblue/dotcom-api/vertex-search";

export const SearchResult = (data: VertexSearchResult) => (
  <li>
    <Link className="flex w-fit focus-outline" href={data.link} target="_self">
      <h3 className="mb-1 text-title-s font-extrabold text-foreground-primary">
        {data.title}
      </h3>
    </Link>
    <p
      className="text-body"
      dangerouslySetInnerHTML={{ __html: data.htmlSnippet }}
    />
  </li>
);
